<!--
  App shell. Persona-aware chrome around a SINGLE content-projection slot.

  IMPORTANT: this template contains exactly ONE <ng-content>, rendered unconditionally.
  Angular projects the app's single projected node (the <router-outlet>) into one slot
  only — an earlier version had four <ng-content> slots (one per persona @case) and the
  outlet landed in just one of them, so every authenticated persona rendered an empty
  content area. Here the sidebar / header / bottom-nav chrome is switched with @if while
  the projected content always lives in the one <ng-content>; persona modifier classes
  restore each mode's layout (vendor sidebar+topbar, admin console, customer centered,
  bare login).
-->
<!-- `mode` (displayMode) drives ALL chrome — NOT raw persona — so bare routes (/auth, /reupload)
     render chrome-less even for a logged-in admin/vendor who opens the link in their own session. -->
@let mode = displayMode();

<div class="app"
     [class.cmode]="mode === 'customer'"
     [class.amode]="mode === 'admin'">

  @if (mode === 'vendor') {
    <app-sidebar
      [open]="drawerOpen()"
      (close)="closeDrawer()"
      (switchVendor)="onSwitchVendor()"></app-sidebar>
    <div class="sb-overlay" [class.show]="drawerOpen()" (click)="closeDrawer()"></div>
  } @else if (mode === 'admin') {
    <app-admin-sidebar></app-admin-sidebar>
  }

  <div class="main"
       [class.admin-main]="mode === 'admin'">

    @if (mode === 'vendor') {
      <app-header (switchVendor)="onSwitchVendor()"></app-header>
    }

    <div class="content">
      <ng-content></ng-content>
    </div>

    <!-- Site-wide footer: the operating company, nothing else. It has to be visible on the site
         itself (payment partner onboarding), so it renders on EVERY page and persona — except the
         admin console, whose fixed 100dvh shell owns its own scroll regions and would have a flow
         footer overlap them. `.has-nav` clears the fixed mobile bottom-nav. -->
    @if (mode !== 'admin') {
      <footer class="app-foot" [class.has-nav]="mode === 'vendor' || mode === 'customer'">
        <span class="app-foot-c">{{ copyrightLine }}</span>
      </footer>
    }
  </div>
</div>

@if (mode === 'vendor' || mode === 'customer') {
  <app-bottom-nav [mode]="mode"></app-bottom-nav>
}

<!-- Global toast renderer — shown on every page including login -->
<app-toast-host></app-toast-host>

<!-- Switch-vendor picker (mockup switchModal) — triggered by sidebar + header -->
<app-modal [show]="switchOpen()" title="Act as a vendor"
           subtitle="Switch context to manage another vendor's services." (close)="switchOpen.set(false)">
  <div class="mt12">
    <button class="pick" *ngFor="let o of mv.options()" type="button"
            [class.on]="o.id === personaSvc.currentVendorId()" (click)="chooseVendor(o.id)"
            style="width:100%;text-align:left">
      <div class="dot" style="width:32px;height:32px" [style.background]="o.color + '22'"><app-cat-icon [code]="o.iconCode" [size]="16" [fill]="o.color"/></div>
      <div style="flex:1;min-width:0">
        <div class="b7 fz12">{{ o.name }}</div>
        <div class="muted fz11 mt4">{{ o.categoryLabel }}<ng-container *ngIf="o.area"> · {{ o.area }}</ng-container></div>
      </div>
      <span class="badge green" *ngIf="o.verified">✓</span>
      <span class="badge amber" *ngIf="!o.verified">!</span>
    </button>
    <div class="muted fz12" style="text-align:center;padding:14px 0" *ngIf="!mv.options().length">Loading vendors…</div>
  </div>
</app-modal>
